<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14gWNrz/tc-custom/9780802191038.jpg?1704761334626" alt="This image is the cover for the book Jack of Spades"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Jack of Spades
      </h1>
      <p class="bookDescription body article font2">
        <b>An exquisite, psychologically complex thriller about opposing forces within the mind of one ambitious writer and the delicate line between genius and madness.</b><br/>  <br/> Andrew J. Rush has achieved the kind of critical and commercial success most authors only dream about: He has a top agent and publisher in New York, and his twenty-eight mystery novels have sold millions of copies. Only Stephen King, one of the few mystery writers whose fame exceeds his own, is capable of inspiring a twinge of envy in Rush. But Rush is hiding a dark secret. Under the pseudonym “Jack of Spades,” he pens another string of novels—noir thrillers that are violent, lurid, and masochistic. These are novels that the upstanding Rush wouldn’t be caught reading, let alone writing. When his daughter comes across a Jack of Spades novel he has carelessly left out, she picks it up and begins to ask questions. Meanwhile, Rush receives a court summons in the mail explaining that a local woman has accused him of plagiarizing her own self-published fiction. Before long, Rush’s reputation, career, and family life all come under threat—and in his mind he begins to hear the taunting voice of the Jack of Spades.<br/>  <br/> “Sleek and suspenseful . . . Readers are sure to be gripped and unsettled by [Oates’s] depiction of a seemingly mild-mannered character whose psychopathology simmers frighteningly close to the surface.” —<i>Publishers Weekly</i>, starred review<br/>  <br/> “Just when you think you’ve got her all figured out, Joyce Carol Oates sneaks up behind and confounds you yet again. She does it with a wicked flourish in <i>Jack of Spades</i>.” —<i>The New York Times Book Review</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joyce Carol Oates
      </h2>
      
      <p class="authorDescription body article">Joyce Carol Oates is the author of over seventy books encompassing novels, poetry, criticism, story collections, plays, and essays. Her novel <I>Them </I>won the National Book Award in Fiction in 1970. Oates has been a member of the American Academy of Arts and Letters for more than three decades and currently holds the Roger S. Berlind Distinguished Professorship at Princeton University.&#160;<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Mysterious Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a8e93fca